var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderCountTable" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.data,
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            border: "",
            "max-height": "500"
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50", fixed: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "push_time_date", label: "推送时间" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "shop_name", label: "三方名称" }
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "订单" } },
            [
              _c("el-table-column", {
                attrs: { prop: "sum_order_amount", label: "供货金额" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "售后" } },
            [
              _c("el-table-column", {
                attrs: { prop: "sum_ap_amount", label: "售后确认金额" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "订单" } },
            [
              _c("el-table-column", {
                attrs: { prop: "sum_order_quantity", label: "供货数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fixedNumber")(
                                scope.row.sum_order_quantity
                              )
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "售后" } },
            [
              _c("el-table-column", {
                attrs: { prop: "sum_ap_quantity", label: "售后确认单数" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("fixedNumber")(scope.row.sum_ap_quantity)
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42c624cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42c624cb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/AmountGoodsTable.vue
// module id = null
// module chunks = 